export const TASK_PRIORITIES = ['LOW', 'MEDIUM', 'HIGH', 'CRITICAL'];
export function isTaskPriority(value) {
    return typeof value === 'string' && TASK_PRIORITIES.includes(value);
}
export const TASK_PRIORITY_META = {
    LOW: {
        key: 'LOW',
        label: 'Low',
        description: 'Nice to have. No schedule pressure.',
        weight: 10,
        tone: 'muted',
        icon: 'chevron-down',
        restricted: false,
        notifiesOnReview: false,
    },
    MEDIUM: {
        key: 'MEDIUM',
        label: 'Medium',
        description: 'Normal development work.',
        weight: 20,
        tone: 'neutral',
        icon: 'equal',
        restricted: false,
        notifiesOnReview: false,
    },
    HIGH: {
        key: 'HIGH',
        label: 'High',
        description: 'Important. Should be picked up ahead of normal work.',
        weight: 30,
        tone: 'attention',
        icon: 'chevron-up',
        restricted: false,
        notifiesOnReview: true,
    },
    CRITICAL: {
        key: 'CRITICAL',
        label: 'Critical',
        description: 'Blocking or live-impacting. Restricted so it retains meaning.',
        weight: 40,
        tone: 'critical',
        icon: 'flame',
        restricted: true,
        notifiesOnReview: true,
    },
};
export const PRIORITIES_BY_WEIGHT = [...TASK_PRIORITIES].sort((a, b) => TASK_PRIORITY_META[b].weight - TASK_PRIORITY_META[a].weight);
export function comparePriority(a, b) {
    return TASK_PRIORITY_META[b].weight - TASK_PRIORITY_META[a].weight;
}
//# sourceMappingURL=priority.js.map